import { Component, Inject, Input} from 'ng-metadata/core';
let  isEmpty  = require('lodash/isEmpty');
const get = require('lodash/get');
import {BriefResultService} from '../../briefResult/briefResult.service';
import {FacetService} from '../../facet/facet.service';
import {SearchService} from '../../search.service';
import {SearchFieldsService} from '../../search.fields.service';
import {FavoritesService} from '../../../favorites/favorites.service';
import {EndlessScrollingUtil} from '../../../nddUtils/endlessScollingUtil.service';
import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
import {JwtUtilService} from '../../../security/jwtUtil.service';
import {isBrowserIE} from '../../../infra/browserSniffer';
import {getResultsBulkSize, getScopeList} from '../../../appConfig/appConfigForward';
import {SmoothScrollUtil} from '../../../nddUtils/smoothScrollUtil.service';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {JournalsService} from '../../../journals/journals.service';
import {SearchErrorMessageService} from '../errorMessage/searchErrorMessage.service';
import {PageNavMenuService} from './pageNavMenu/pageNavMenu.service';
import {PnxUtil} from '../../../nddUtils/pnxUtil.service';
import {DatabasesService} from "../../../journals/databases.service";
import {NewspapersService} from '../../../newspapers/newspapers.service';
import {DatabasesCategorizeService} from "../../../journals/databasesCategorize/databasesCategorize.service";
import { MediaQueries } from '../../../infra/mediaQueries.service';

@Component({
    selector: 'prm-search-result-list',
    templateUrl: 'components/search/searchResult/searchResultList/search-result-list.html',
})


export class PrmSearchResultList {

    private _currentPage = 0;
    private expandedItemIndex = -1;
    private expandedItem;
    private initialOffset = 0;
    private isIe = isBrowserIE();
    private PAGE_SIZE = getResultsBulkSize();
    private expandedItemHeight: string;
    private pagingConfigutation: {};
    private _totalResultVersion:number = 0;
    private wasInFullDisplay: boolean = false;
    private scopes = getScopeList();
    private testisOpen: boolean= false;
    private showTimer= false;
    private listBottomSpacer: boolean = false;

    @Input() private categoriesType:string;
    @Input() itemlist: Object[];
    @Input() isFavorites: boolean;
    @Input() isSavedQuery:boolean;
    @Input() isSearchHistory:boolean;
    @Input() links: string[];
    @Input() facetToLeft: boolean;
    @Input() featuredResult;
    @Input() query:string;


    constructor(private briefResultService: BriefResultService,
                private searchService: SearchService,
                private searchFieldsService: SearchFieldsService,
                private facetService: FacetService,
                private pnxUtil : PnxUtil,
                private favoritesService : FavoritesService,
                private endlessScrollingUtil: EndlessScrollingUtil,
                private primolyticsService : PrimolyticsService,
                private jwtUtilService:JwtUtilService,
				private databasesService: DatabasesService,
				private mediaQueries: MediaQueries,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private searchErrorMessageService: SearchErrorMessageService,
                private smoothScrollUtil: SmoothScrollUtil,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$state') private $state: ng.ui.IStateService,
                private journalsService: JournalsService,
                private newspapersService: NewspapersService,
                private databasesCategorizeService:DatabasesCategorizeService,
                @Inject('$location') private $location: ng.ILocationService,
                private pageNavMenuService: PageNavMenuService){
        this.$timeout(()=>{
            this.showTimer= true;
        },2000);
        this.briefResultService = briefResultService;
        this.briefResultService.resetIsChosen();
        this.briefResultService.buildJsonOdIdsAndPins();
        if(searchService.getSearchObject() && searchService.getSearchObject().offset) {
            this.initialOffset = searchService.getSearchObject().offset - (searchService.getSearchObject().offset % this.PAGE_SIZE); //we round down to offset of beginning of nearest page
        }
        this.pageInView= Math.floor((this.$stateParams['offset'] || 0)/ this.PAGE_SIZE) + 1; //init page in view to the first loaded page
        this.pageNavMenuService.needToUpdatePivInSafari = false;
    }


    ngOnInit(){
        this.$scope.$watch(()=>this.itemlist, (newVal, oldVal)=>{
            if (newVal) {
                 newVal.forEach((e)=> {
                     if (e.context === 'MetaLib') {
                         this.pagingConfigutation = {
                            firstPage : false,
                            paging : false
                         }
                     }
                 });
            }
            this._totalResultVersion = this.recordsNumberInludeFrbr;

        });

    }
    get indeterminateState(){
        if(this.briefResultService.checkIfAllSelected() ||  this.briefResultService.getChosenRecords().length === 0){
            return false;
        }
        return true;

    }
    get categoryResultCode(){
        if (this.categoriesType=='db')
            return 'dbcategories.results';
        if (this.categoriesType=='journal')
            return 'nui.journalsearch.category.result';
        else
            return 'result';
    }


    get allIn(){
        return this.briefResultService.checkIfAllSelected()? true:false;
    }

    public showFeaturedResults(index:number):boolean{
        if(!this.featuredResult){
            return false;
        }
        if(this.itemlist.length === 0){
            return false;
        }
        if(this.itemlist.length == 1 || (this.itemlist.length == 2 && index == 1)){
            return true;
        }
        else{
            if(index == 2){
                return true;
            }
        }
        return false;

    }

    public selectOrUnselectAll(){
        this.briefResultService.selectAll= !this.allIn;
        this.briefResultService.chooseAll();
    }
    
    public isFetchingAllItems() {
        return this.favoritesService.isFetchingAllItems;
    }


    private get isAtozSearch(){
        return this.journalsService.isJournalSearch() || this.databasesService.isDBSearch();
    }

    private get isNewspapersSearch() {
        return this.newspapersService.isNewspapersSearch();
    }


    get totalResultVersion(): number {
        return this._totalResultVersion;
    }

    private firstInPage(index) {
        return (index === 0) || ((index % this.itemsPerPage) === 0)
    }


    public shouleFeaturedResultsApear(): boolean {
        if (this.itemlist.length === 0 || this.featuredResult === undefined || this.featuredResult.featuedResultsItems.length < 4) {
            return false;
        }
        else{

        }


        return true;
	}
	
	 private detectMobile() {
        if (this.mediaQueries.xs || this.mediaQueries.sm || this.mediaQueries.md) {
            return true;
        }
        return false;
    }

    private lastInPage(index){
        return ((index % this.itemsPerPage) === (this.itemsPerPage -1));
    }

    private calcPage(index) {
        return 1 + this.getItemOffset(index) / this.itemsPerPage;
    }

    private get currentPage() {
        return this._currentPage + 1;
    }

    private set currentPage(page) {
        this._currentPage = page - 1;
    }

    private get itemsPerPage() {
        return this.PAGE_SIZE;
    }

    private isDisabled() {
        return this.searchInProgress;
    }


    private offset() {
        return this.searchService.getSearchObject().offset - (this.searchService.getSearchObject().offset % this.PAGE_SIZE); //we round down to offset of beginning of nearest page
    }

    private from() {
        return this.offset() + 1;
    }
    private to() {
        return this.searchService.getSearchObject().to
    }


    private get selectedItem() {
        return this.searchService.getSelectedItem();
    }

    private get searchInProgress() {
        return this.searchService.isSearchInProgress();
    }


    private get imagesBarFillersList() {
        return this.searchService.getResultObject().images;
    }


    private get searchResults() {
        return this.searchService.getResultObject().data;
    }

    private get resultsExists() {
        return !(isEmpty(this.searchService.getResultObject().info));
    }

    public isShowMoreResultButton() {
        let info = this.searchService.getResultObject().info;
        return this.resultsExists && Number(info.last)<info.total;
    }

    public isShowFetchMoreResultButton() {
        let info = this.searchService.getResultObject().info;
        return this.resultsExists && info.total<info.maxTotal;
    }

    private get searchInfo() {
        return this.searchService.getResultObject().info;
    }

    private get searchString() {
        return this.searchService.searchFieldsService._mainSearch;
    }

    private get didUMean(){
        return this.searchService.getResultObject().didUMean;
    }

    private get controlledVocabulary() {
        return get(this,['searchInfo','controlledVocabulary']);
    }

    private get errorCode() {
        let info = this.searchInfo;
        if(info && info.errorDetails) {
            if(this.searchInfo.errorDetails.errorCode === 'controlled.voc.synonym'){
                return null;
            }
            return this.searchInfo.errorDetails.errorCode;
        }
        return null;
    }

    private get errorMessage() {
        let info = this.searchInfo;
        if(info && info.errorDetails) {
            return this.searchInfo.errorDetails.errorMessages;
        }
        return null;

    }
    
    private get explainMessage() {
        let info = this.searchInfo;
        if(info && info.explain) {
            return this.searchInfo.explain.errorMessages[0];
        }
        return null;
    }
    
    private getLength() {
        let info = this.searchInfo;
        if(info) {
            return info.total;
        }
        else {
            return 2;
        }
    }

    private get totalItems() {
        return this.getLength();
    }
    private getItemAtIndex(index) {
        return this.searchService.getItemAtIndex(index);

    }

    private getNgRepeatItemId(item, index) {
        return item.pnx.control.recordid[0]+'-'+index;
    }

    private showPin(item){
        return this.briefResultService.getShowPinForRecordId(item.pnx.control.recordid[0]);
    }

    private hasNextResults() {
        return this.searchService.needToGetNextResults();
    }

    /**
     * @ngdoc method
     * @name nextResults
     * @methodOf starter.controller:SearchController
     * @description
     * Gets the next bulk of search results of the current search
     */
    private nextResults() {
        if (!this.endlessScrollingUtil.isSearchEndlessScrollingEnabled){ //if endless scrolling was disabled do nothing
            return;
        }

        if (this.searchService.needToGetNextResults()) {
            this.callSearchServiceNextResultsWithBeacon();
        }
        else{
            this.callSearchServiceNextResults();
        }
    }

    private jumpToPage(p) {
        let page = p-1;
        this.searchService.jumpToPage(page);
        this._currentPage = page;
    }

    @beacon({'p':'brief', 'op':'next'})
    private callSearchServiceNextResultsWithBeacon() {
        this.callSearchServiceNextResults();
    }

    private callSearchServiceNextResults() {
        let promise= this.searchService.nextResults(this.isIe);
        // let promise= this.searchService.nextResults();
        if (promise && !this.isIe){  //wait for the new results to be loaded and then increment the num of loaded pages
            promise.then(()=>{
                let offset= this.$stateParams['offset'] || 0;
                let startPage= Math.floor(offset/ this.PAGE_SIZE) + 1;
                let newPageNum= startPage + this.numOfLoadedPages -1;
                this.$timeout(()=>{
                    this.smoothScrollUtil.scrollTo('searchResultPage'+ newPageNum, null, null);
                },0, false);
            });
        }
    }

    private get numOfLoadedPages(){
        return this.searchService.numOfLoadedResultBulks;
    }

    private getPlaceHolders() {


        return {
            idx_0: this.favoritesService.getTotalItems()
        };
    }


    private getPlaceHoldersForFilter() {
        return {
            idx_0: this.favoritesService.getCountRecords(),
            idx_1: this.favoritesService.getTotalItems()
        };


    }


    public selectAll() {
         this.briefResultService.chooseAll();
    }


    private isExpanded(index) {
        return this.expandedItemIndex === index;
    }
    private setExpandedItem($event, index) {
        if($event.expand) {
            this.expandedItemHeight = $event.target.parentNode.offsetHeight + 'px';
            this.expandedItemIndex = index;
            this.toggleListBottomSpacer(true);
        }
        else {
            this.expandedItemHeight = '';
            this.expandedItemIndex = -1;
            this.toggleListBottomSpacer(false);
        }

    }

    private toggleListBottomSpacer(bool){
        this.listBottomSpacer = bool
    }

    private selectedItemHeight() {
        this.expandedItemHeight;
    }

    get skipLinks(){
        return this.links;
    }
    private getItemOffset(index) {
        if(this.isIe) {
            return this.offset() + index;
        }
        else {
            return this.initialOffset + index;
        }
    }
    private getItemIndex(index) {
        return this.getItemOffset(index) + 1

    }

    private isSignedIn(){
        let isUser = this.jwtUtilService.getDecodedToken().userGroup;
        if (isUser === 'GUEST'){
            return false;
        }
        return true;
    }

    private shouldDisableSavingQuery(){
        let info = this.searchInfo;
        if(info && info.errorDetails && info.errorDetails.errorCode === this.searchErrorMessageService.tooManyClauses) {
            return true;
        }
        return false;
    }

    private showPartialResultsWarning(){
        let info = this.searchInfo;
        if(info && info.errorDetails && this.itemlist.length != 0 && (info.errorDetails.errorCode === this.searchErrorMessageService.blendedTimeout
                                        || info.errorDetails.errorCode === this.searchErrorMessageService.tooManyClauses
                                        || info.errorDetails.errorCode === this.searchErrorMessageService.notAllSlicesSearched)) {
            return true;
        }
        return false;
    }

    private onTopOfPageInView(pageNum, $inview, $inviewInfo){

        let noPaginationPaths = ['/fulldisplay','/jfulldisplay','/npfulldisplay'];
        if (noPaginationPaths.indexOf(this.$location.$$path)>=0) {
            this.wasInFullDisplay = true;
            return;
        }
        
        if (!$inview){
            return;
        }
        
        let halfOfViewport= $inviewInfo.viewportRect.height / 2;
        if ($inviewInfo.elementRect.top < halfOfViewport){
            if ((this.pageInView !== pageNum && pageNum !== 1 && !this.wasInFullDisplay) || this.needToUpdatePivInSafari) {
                    this.pageInView = pageNum;
           }
            return;
        }
        let offset= this.$stateParams['offset'] || 0;
        let startPage= Math.floor(offset/ this.PAGE_SIZE) + 1;
        
        if ((!(this.pageInView === startPage)) && (pageNum === this.pageInView) && ($inviewInfo.elementRect.top > halfOfViewport)){
            this.pageInView--;
        }
        
        this.wasInFullDisplay = false;
    }

    private onBottomOfPageInView(pageNum, $inview, $inviewInfo){
        //console.log('bottom of page in view!!!!' + pageNum);
    }

    private isCitationState() {
        return this.$state.current.name === STATE_NAMES.CITATION_TRAILS;
    }
    
    private isSearchState() {
       return this.$state.current.name === STATE_NAMES.SEARCH;
    }

    private isBrowsHeaderResults(){
        return this.$stateParams ['mode'] === 'browse';
    }

    private notLocal() {
        return !this.searchService.IsScopeLocal();
    }

    private shouldDisplayPagingWidget() {
        return this.$state.current.name === STATE_NAMES.SEARCH || this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH
            || this.$state.current.name === STATE_NAMES.DB_SEARCH || this.$state.current.name === STATE_NAMES.CITATION_TRAILS
            || this.$state.current.name === STATE_NAMES.CITATION_CHAPTERS || this.$state.current.name === STATE_NAMES.NEWSPAPERS
            || this.$state.current.name === STATE_NAMES.ORGANIZATION_LIST;
    }

    get needToUpdatePivInSafari(){
        return this.pageNavMenuService.needToUpdatePivInSafari;
    }
    
    set needToUpdatePivInSafari(isNeedToUpdate){
        this.pageNavMenuService.needToUpdatePivInSafari = isNeedToUpdate;
    }
    
    get pageInView(){
        return this.pageNavMenuService.pageInView;
    }

    set pageInView(updatedPage){
        this.pageNavMenuService.pageInView= updatedPage;
    }


    get recordsNumberInludeFrbr(): number {
        if (this.$stateParams ['mode'] != 'browse' || this.briefResultService.isSuprima()) {
            return 0;
        }
        let browseResultNumber:number = Number(this.$stateParams['docCount']);
        if(this.searchInfo == undefined){
            return 0;
        }

        if(this.searchInfo.total >= browseResultNumber || this.inFrbrMode) {
            return 0;
        }
        return  browseResultNumber;


    }


    get inFrbrMode(): boolean {
        let facet = this.$stateParams["facet"];
        if(facet == undefined){
            return false;
        }
        if (facet instanceof Array) {
            for(let temp of facet){
                if(temp.startsWith("frbrgroupid,")){
                    return true;
                }
            }
            return false;
        }
        else{
            return facet.startsWith("frbrgroupid,")? true:false;
        }
    }

    private displayNewspapersLink() {
        return this.newspapersService.displayNewspapersLink();
    }


    private getDBParamTerm(){
        let term;
        if (this.categoriesType=='db')
            term=this.$stateParams['databases'];
        if (this.categoriesType=='journal')
            term=this.$stateParams['journals'];
        if(!term){
            term=this.$stateParams['query'];
        }
        let subterm = term.substring(term.indexOf(',')+1);
        if(subterm && subterm.length>0){
            return subterm;
        }else{
            return term;
        }
    }
  	
  	
    public getDefaultTerm(){
       	let dbt=this.getDBParamTerm();
       	let dbParamArray = dbt.split(this.databasesCategorizeService.DELIMITER);
       	if(dbParamArray && dbParamArray.length>0){
       	    if (this.categoriesType=='journal')
       	        return 'nui.journalsearch.category.lvl'+dbParamArray.length+'.'+dbParamArray[dbParamArray.length-1];
       		return dbParamArray[dbParamArray.length-1];
       	}else{
       		return dbt;
       	}
    }
    
   public getDynamicTop(){
       let elemHeight : number =  document.getElementById('errorCodeMsg').offsetHeight;
       return (elemHeight + 6)+ 'px';
   }

    get categoryTerm(){
        if (this.categoriesType=='journal')
            return  this.getDefaultTerm();
        if (this.categoriesType=='db')
            return 'dbcategories.'+this.databasesCategorizeService.getTName(this.getDBParamTerm());
        else
            return this.databasesCategorizeService.getTName(this.getDBParamTerm());
    }
  
    public isCategoriesSearch() {
        return this.databasesCategorizeService.isSearchFromCategoryTree();
    }



    private isChaptersAndReviewsState() {
        return this.$state.current.name == STATE_NAMES.CITATION_CHAPTERS;
    }

    private isNgrsSearch(){
        let scopesOptions = this.scopes.map(function (obj){ return obj.tab;});
        if(window.appConfig['system-configuration'].ngrs_enabled && scopesOptions.indexOf("RAPIDXL") > -1){
            return (this.journalsService.isJournalSearch() && !this.databasesCategorizeService.isSearchFromCategoryTree())
        }
        return false;  
    }

}






// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/searchResult.directive.ts